import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons'; // usersアイコンをインポート
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出

const CounterPC = () => {
  const count = 12; // プレイヤー数の固定値

  return (
    <div className="absolute top-16 right-0.5 bg-white border border-gray-300 rounded-lg shadow-lg z-10 flex items-center justify-center
      w-1/8 h-1/6
      md:w-1/6 md:h-1/4
      lg:w-1/8 lg:h-1/5
      p-4"
      style={{
        minWidth: '100px',  // Set the minimum width
        minHeight: '140px'   // Set the minimum height
      }}>
      <div className="flex flex-col items-center">
        <FontAwesomeIcon icon={faUsers} className="text-gray-600 mb-2 
          w-10 h-10
          md:w-12 md:h-12
          lg:w-16 lg:h-16" /> {/* usersアイコン */}
        <p className="font-semibold text-3xl
          md:text-4xl
          lg:text-5xl">{count}</p>
        <p className="text-sm font-semibold mt-2
          md:text-base
          lg:text-lg">Num.Participants</p> {/* 文字サイズを小さくしました */}
      </div>
    </div>
  );
}

const CounterMobile = () => {
  const count = 12; // プレイヤー数の固定値

  return (
    <div className="absolute top-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg z-10 flex items-center justify-center
      w-1/8 h-1/8
      md:w-1/2 md:h-1/4
      lg:w-1/8 lg:h-1/5
      p-2"
      style={{
        minWidth: '80px',  // Set the minimum width
        minHeight: '40px'   // Set the minimum height
      }}>
      <div className="flex flex-col items-center">
        <FontAwesomeIcon icon={faUsers} className="text-gray-600 mb-1
          w-5 h-5
          md:w-12 md:h-12
          lg:w-16 lg:h-16" /> {/* usersアイコン */}
        <p className="font-semibold text-xl
          md:text-2xl
          lg:text-5xl">{count}</p>
        <p className="font-semibold mt-1
          md:text-base
          text-xs">Participants</p> {/* 文字サイズを小さくしました */}
      </div>
    </div>
  );
}

function PlayerCounter() {
  return isMobile ? <CounterMobile /> : <CounterPC />;
}

export default PlayerCounter;
